import Box from "@/common/components/Box";
import { maintenanceForwardingsDirectiveEntryKlasses } from "@/features/maintenance/features/workflows/constants/forwardings/maintenanceForwardingsDirectiveEntryKlasses.constant";
import { maintenanceForwardingsDirectiveEntryStateStatus } from "@/features/maintenance/features/workflows/constants/forwardings/steps/directiveEntry/maintenanceForwardingsDirectiveEntryStateStatus.constant";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { useMemo } from "react";
import DirectiveEntryExecutionEntryDiagnostic from "./content/ExecutionEntryDiagnostic";
import DirectiveEntryExecutionEntryExecution from "./content/ExecutionEntryExecution";
import DirectiveEntryExecutionEntryCompleted from "./content/ExecutionEntryCompleted";
import { fiscalAssessmentDocumentGroupsKind } from "@/features/maintenance/features/workflows/constants/forwardings/steps/fiscalAssessmentEntry/fiscalAssessmentDocumentGroupsKind.constant";
import { DocumentFileList } from "@/common/components/DocumentFileList";
import { getFilenameFromUrl } from "@/common/utils/getFilenameFromUrl";

interface MaintenanceWorkflowForwardingDirectiveEntryExecutionEntryProps {
  showDiagnostic?: boolean;
  showExecution?: boolean;
  showCompleted?: boolean;
  showFiscalAssessmentsDocuments?: boolean;
}

const MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry = ({
  showDiagnostic,
  showExecution,
  showCompleted,
  showFiscalAssessmentsDocuments,
}: MaintenanceWorkflowForwardingDirectiveEntryExecutionEntryProps) => {
  const { forwarding, forwardingUpdatedAt, directiveEntryKlass } = useForwardingTabContext<
    MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry
  >();

  const DirectiveEntryStatusComponent = useMemo(() => {
    const directiveEntryStatusData = maintenanceForwardingsDirectiveEntryStateStatus[MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry]?.status[forwarding.status];

    if (!directiveEntryStatusData) {
      return false;
    }

    return directiveEntryStatusData.component || false;
  }, [forwardingUpdatedAt, directiveEntryKlass]);

  return (
    <Box className="p-4 flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-lg font-semibold">
            {maintenanceForwardingsDirectiveEntryKlasses[forwarding.directive_entry_type]?.label}
          </p>
        </div>

        <div>
          {DirectiveEntryStatusComponent && (
            <DirectiveEntryStatusComponent />
          )}
        </div>
      </div>

      {showDiagnostic && (
        <DirectiveEntryExecutionEntryDiagnostic />
      )}

      {showExecution && (
        <DirectiveEntryExecutionEntryExecution />
      )}

      {showCompleted && (
        <DirectiveEntryExecutionEntryCompleted />
      )}

      {showFiscalAssessmentsDocuments && (
        <>
          {forwarding?.fiscal_assessment_entry?.document_groups?.map((documentGroup) => (
            <div
              key={documentGroup.id}
              className="flex flex-col gap-2"
            >
              <div className="flex items-center justify-between">
                <div>
                  <p>
                    {fiscalAssessmentDocumentGroupsKind[documentGroup.kind] || documentGroup.kind}
                  </p>
                </div>
              </div>

              {Number(documentGroup.documents.length) > 0 ? (
                <DocumentFileList
                  files={documentGroup.documents.map((document) => ({
                    currentFileUrl: document.file.url,
                    fileName: getFilenameFromUrl(document.file.url),
                  }))}
                  className="h-[120px] w-[220px] p-3 rounded-md"
                />
              ) : (
                <div className="h-48 overflow-hidden flex flex-col items-center gap-0 bg-white-100 rounded-md">
                  <img
                    src="/search.gif"
                    className="h-40 -mt-4 pointer-events-none select-none"
                  />

                  <p className="text-sm text-center -mt-2">
                    Não há notas fiscais aqui
                  </p>
                </div>
              )}
            </div>
          ))}
        </>
      )}
    </Box>
  );
}

export default MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry;
